import { reduce } from "lodash";

import { GET_MAPPINGS } from "./mappingsTab/gql";
import { MAPPING_LEVELS } from "./constants";
import { showInfoToast, showSuccessToast } from "@src/appV2/lib/Notifications";

const ACTION_TYPE = {
  ADDED: "ADDED",
  DELETED: "DELETED",
  UPDATED: "UPDATED",
};

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const unwindLevels = (levels: any) => {
  const map = {
    [MAPPING_LEVELS.GLOBAL]: [MAPPING_LEVELS.GLOBAL],
    [MAPPING_LEVELS.LOCATION]: [MAPPING_LEVELS.STATE, MAPPING_LEVELS.MSA, MAPPING_LEVELS.COUNTY],
    [MAPPING_LEVELS.HCF]: [MAPPING_LEVELS.HCF],
  };
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return reduce(levels, (res, type) => [...res, ...map[type]], [] as any[]);
};

const updateMappingsCache =
  ({ _id, actionType, filter, hcfId }) =>
  (cache, { data: modifiedData }) => {
    const data = cache.readQuery({
      query: GET_MAPPINGS,
      variables: { hcfId, levels: unwindLevels(filter) },
    });
    let updatedData = [...data.mappings];
    const incoming =
      modifiedData.createRequirementMapping ||
      modifiedData.updateRequirementMapping ||
      modifiedData.deleteRequirementMapping;
    let insert = true;

    // Check if we have to replace a mapping (due it it being an edited or merged mapping)
    if (actionType !== ACTION_TYPE.DELETED) {
      const message = `We're going to merge the mapping into an existing one at ${incoming.level} level`;
      // A merging occurred during update
      if (_id && incoming._id !== _id) {
        updatedData = data.mappings.filter((mapping) => mapping._id !== _id);
        showInfoToast(message);
      }
      updatedData = data.mappings.map((mapping) => {
        if (mapping._id === incoming._id) {
          insert = false;
          return incoming;
        }

        return mapping;
      });

      // A merging occurred during insertion
      if (!_id && !insert) {
        showSuccessToast(message);
      }

      // If mapping wasn't inserted already, it's a new one.
      if (insert) {
        updatedData.push(incoming);
      }
    } else {
      const indexToRemove = updatedData.findIndex((mapping) => mapping._id === incoming);

      updatedData.splice(indexToRemove, 1);
    }

    cache.writeQuery({
      query: GET_MAPPINGS,
      data: { ...data, mappings: updatedData },
    });
  };

export { ACTION_TYPE, updateMappingsCache, unwindLevels };
